import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Box, Hidden } from '@material-ui/core';
import DiscussionMessage from './discussionMessage';
import ListDiscussions from './listDiscussions';
import Menu from './menu';
import useStyles from './styles';

const AllDiscussions: React.FC = () => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  return (
    <>
      <Menu />
      <Box className={classes.wrapper}>
        <Hidden smDown>
          <Route
            path={`${path}/:id?`}
            render={(_) => (
              //@ts-ignore
              <ListDiscussions discussionId={+_.match.params.id} />
            )}
          />
          <Switch>
            <Route
              path={`${path}/:id`}
              render={(_) => (
                <DiscussionMessage discussionId={+_.match.params.id} />
              )}
            />
          </Switch>
        </Hidden>
        <Hidden mdUp>
          <Switch>
            <Route exact path="/allDiscussions" component={ListDiscussions} />
            <Route
              path={`${path}/:id`}
              render={(_) => (
                <DiscussionMessage discussionId={+_.match.params.id} />
              )}
            />
          </Switch>
        </Hidden>
      </Box>
    </>
  );
};
export default AllDiscussions;
